<template>
  <div class="page autoctoni">
    <ListingList
      :indexes="indexes"
      :defaultFacetsFilters="defaultFacetsFilters"
      :filter="filter"
      :currentCustomContent="currentSubCategory"
      :pageHandle="vinoPage.typeHandle"
      :categories="categories"
      :subcategories="subcategories"
      :introSection="currentSubCategory.sezioneIntroProdotti[0]"
      :parentIntroSectionImage="vinoPage.sezioneIntroProdotti[0].portrait"
      :hideSidebar="true"
      :hideListing="true"
    >
      <template v-slot>
        <GeneralHeader
          v-for="(header, index) in currentSubCategory.generalHeader"
          :key="index"
          :header="header"
          customStyle="no-top no-row"
        />
        <TitleText
          v-for="(item, index) in currentSubCategory.sezioneTitoloTestoPagina"
          :key="index"
          :item="item"
          customStyle="no-row"
        />
        <TextImageWithBg
          v-for="(block, index) in currentSubCategory.sezioneImmagineTesto"
          :key="index"
          :block="block"
          type="custom3"
          customStyle="no-row"
        />
        <FullImageTitleText
          v-for="(
            content, index
          ) in currentSubCategory.sezioneImmagineVideoFull"
          :key="index"
          :content="content"
          type="default"
        />
      </template>
    </ListingList>
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { parseQueryFacets } from '~/assets/js/utils/algolia.js'
import {
  useVinoData,
  generateVinoDefaultFacetsFilters,
} from '~/composables/vino-data.js'
import { useHelpers } from '~/composables/helpers.js'

const route = useRoute()
const indexes = ['section_vino']
const filter = route.query?.filter ? parseQueryFacets(route.query?.filter) : []

const { configuration } = useStore()

const query = queries.vinoPage.getVinoPage
const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)
if (!data.value.vinoPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const { categories, subcategories } = useVinoData(data)

const currentCategory = computed(() => {
  return (
    data.value.categories.find(
      (category) => category.slug === route.params.slug,
    ) || {}
  )
})

const currentSubCategory = computed(() => {
  return (
    data.value.categories.find((category) => category.key === 'autoctoni') || {}
  )
})

const isValidCategory = computed(() => {
  return (
    currentCategory.value.key === 'lieviti' &&
    currentSubCategory.value.key === 'autoctoni'
  )
})

if (!isValidCategory.value) {
  throw createError({ statusCode: 404 })
}

const defaultFacetsFilters = computed(() => {
  const defaultFacets = generateVinoDefaultFacetsFilters(
    currentCategory,
    currentSubCategory,
  )

  return [...defaultFacets]
})

const seo = computed(() => currentSubCategory.value.seo || {})

const localeParams = computed(() => currentCategory.value.localized || [])

useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})

const vinoPage = computed(() => data.value.vinoPageEntries?.[0])
</script>
